/** 官网静态数据 */
export const siteInfo = {
  name: '拼遇好物',
  /** 应用开发主体，须与华为/应用市场上架主体一致（支付资质审核截图用） */
  developerName: '友纪网络技术服务部（个体工商户）',
  packageName: 'com.yuki.pinyuhaowu',
  slogan: '拼好货，遇好物',
  tagline: '精选日常好物，购物更省心',
  description:
    '拼遇好物是一款面向日常消费场景的移动端购物应用。用户可在 App 内完成商品浏览、下单支付、订单管理与在线客服沟通，享受从选购到售后的完整服务体验。',
  version: '1.0.0',
}

/** Android 安装包静态下载（public/download，构建后位于站点根路径 /download/） */
export const androidDownload = {
  url: '/download/pinyuhaowu.apk',
  fileName: 'pinyuhaowu.apk',
  label: '下载 Android 版',
  hint: '适用于 Android 手机',
}

export const contactInfo = {
  phone: '15987975869',
  email: '2950953373@qq.com',
  workTime: '周一至周日 9:00 - 21:00',
  wechat: '拼遇好物',
}

export const navMenus = [
  { path: '/', name: 'Home', label: '首页' },
  { path: '/shop', name: 'Shop', label: '商品选购' },
  { path: '/about', name: 'About', label: '关于我们' },
  { path: '/features', name: 'Features', label: '产品功能' },
  { path: '/contact', name: 'Contact', label: '联系我们' },
]

/** 官网展示用商品（API 不可用时兜底，满足支付资质审核展示） */
export const shopProducts = [
  {
    id: 1,
    productName: '蓝月亮洗衣液 3kg 瓶装',
    details: '深层洁净、低泡易漂，适用于棉麻及合成纤维织物日常洗涤。',
    price: 39.9,
    specHint: '规格：3kg/瓶 · 库存充足',
    category: '洗衣清洁',
  },
  {
    id: 2,
    productName: '舒肤佳沐浴露 750ml',
    details: '温和清洁，持久留香，全家适用，沐浴后肌肤清爽不紧绷。',
    price: 28.5,
    specHint: '规格：750ml/瓶 · 支持多规格',
    category: '沐浴洗护',
  },
  {
    id: 3,
    productName: '立白洗洁精 1.5kg',
    details: '去油力强，食品用配方，餐具锅具清洁更省心。',
    price: 15.8,
    specHint: '规格：1.5kg/瓶',
    category: '家居清洁',
  },
  {
    id: 4,
    productName: '维达抽纸 3层 130抽×20包',
    details: '柔韧厚实，家庭装实惠组合，日常擦拭与餐用均可。',
    price: 49.9,
    specHint: '规格：130抽×20包/箱',
    category: '纸品百货',
  },
  {
    id: 5,
    productName: '海飞丝去屑洗发水 750ml',
    details: '清爽去屑，改善头屑困扰，适合油性及中性发质。',
    price: 45.0,
    specHint: '规格：750ml/瓶',
    category: '沐浴洗护',
  },
  {
    id: 6,
    productName: '奥妙洗衣凝珠 50颗装',
    details: '一颗洗净多件衣物，遇水即溶，留香持久。',
    price: 59.9,
    specHint: '规格：50颗/盒',
    category: '洗衣清洁',
  },
]

/** 售后服务说明（支付资质审核需可见） */
export const afterSalesPolicy = {
  title: '售后服务说明',
  items: [
    {
      title: '配送与签收',
      desc: '订单支付成功后 1-3 个工作日内安排发货；签收前请当面验货，如有破损可拒收并联系客服。',
    },
    {
      title: '退换货规则',
      desc: '未拆封商品在签收后 7 日内，因质量问题或与描述不符可申请退货退款；定制类商品除外。',
    },
    {
      title: '退款流程',
      desc: '在 App「订单」页进入「联系客服」提交退款申请，平台 1-3 个工作日审核；审核通过后原路退回（微信/余额）。',
    },
    {
      title: '运费说明',
      desc: '因商品质量问题产生的退货运费由平台承担；非质量原因的退货运费由用户承担。',
    },
  ],
}

/** 客诉与纠纷处理 */
export const complaintPolicy = {
  title: '客诉与纠纷处理',
  items: [
    {
      title: '投诉渠道',
      desc: '客服电话 15987975869、邮箱 2950953373@qq.com、App 内订单客服聊天，工作日 9:00-21:00 受理。',
    },
    {
      title: '响应时效',
      desc: '一般咨询 24 小时内回复；退款/纠纷类 3 个工作日内给出处理方案。',
    },
    {
      title: '争议处理',
      desc: '双方协商不成的，用户可向平台所在地消费者协会或相关监管部门投诉，平台配合提供订单凭证。',
    },
  ],
}

/** 支付方式说明 */
export const paymentInfo = {
  methods: ['微信支付', '账户余额支付'],
  note: '点击「立即购买」弹出支付窗口，使用微信扫码或微信内完成支付。',
}

export const heroStats = [
  { value: '100+', label: '精选商品' },
  { value: '4', label: '核心品类' },
  { value: '7×12', label: '客服在线' },
  { value: '1', label: 'App 全链路' },
]

export const featureList = [
  {
    icon: 'el-icon-goods',
    title: '精选好物',
    desc: '首页热卖推荐与分类浏览，支持关键词搜索，快速找到所需商品。',
  },
  {
    icon: 'el-icon-shopping-cart-full',
    title: '便捷下单',
    desc: '多规格选择、地址管理、余额支付，下单流程简洁清晰。',
  },
  {
    icon: 'el-icon-s-order',
    title: '订单追踪',
    desc: '待付款、待发货、已发货、已完成等状态实时可查，订单信息一目了然。',
  },
  {
    icon: 'el-icon-chat-dot-round',
    title: '在线客服',
    desc: '每个订单可独立发起客服会话，支持文字与图片沟通，售后响应及时。',
  },
  {
    icon: 'el-icon-refresh-left',
    title: '退款保障',
    desc: '在客服聊天内提交退款申请，平台审核通过后按流程处理，保障用户权益。',
  },
  {
    icon: 'el-icon-location-outline',
    title: '地址管理',
    desc: '支持地图选点添加收货地址，下单时可灵活选择，配送信息准确无误。',
  },
]

export const appScreens = [
  { title: '首页推荐', desc: '公告滚动、热卖 TOP 榜单、商品搜索', tag: '发现好物' },
  { title: '分类选购', desc: '左侧品类导航，右侧商品列表，选购更高效', tag: '分类浏览' },
  { title: '商品详情', desc: '图文详情、多规格选择、一键购买', tag: '了解商品' },
  { title: '确认订单', desc: '选择地址与支付方式，余额快捷结算', tag: '安全支付' },
  { title: '订单管理', desc: '查看全部订单状态，联系客服处理售后', tag: '订单中心' },
  { title: '客服聊天', desc: '文字图片沟通，退款申请与进度通知', tag: '售后保障' },
]

export const productCategories = [
  { name: '洗衣清洁', desc: '洗衣液、洗衣凝珠、柔顺剂等' },
  { name: '沐浴洗护', desc: '沐浴露、洗发水、护发素等' },
  { name: '家居清洁', desc: '清洁剂、垃圾袋、护理套装等' },
  { name: '纸品百货', desc: '礼盒套装及日常百货用品' },
]

export const orderFlow = [
  { step: '01', title: '浏览选购', desc: '首页/分类发现商品，查看详情并选择规格' },
  { step: '02', title: '提交订单', desc: '确认收货地址与支付金额，创建订单' },
  { step: '03', title: '完成支付', desc: '支持微信支付、账户余额支付' },
  { step: '04', title: '商家发货', desc: '订单进入待发货状态，物流信息可追踪' },
  { step: '05', title: '售后客服', desc: '如有问题可联系在线客服或申请退款' },
]

export const aboutValues = [
  { title: '品质优先', desc: '严选日常消费品类，注重实用与性价比。' },
  { title: '服务为本', desc: '订单级客服与退款审核机制，售后有保障。' },
  { title: '体验至上', desc: '简洁的 App 交互设计，让购物过程轻松顺畅。' },
]

export const faqList = [
  {
    q: '拼遇好物 App 在哪里下载？',
    a: 'Android 用户可直接在官网首页点击「下载 Android 版」，或访问 /download/pinyuhaowu.apk 下载安装包。iOS 版本筹备中，敬请关注。',
  },
  {
    q: '支持哪些支付方式？',
    a: '支持微信支付与账户余额支付。在 App 确认订单页选择支付方式即可完成付款。',
  },
  {
    q: '如何申请退款？',
    a: '请在 App 订单页进入「联系客服」，在聊天界面底部点击「申请退款」并填写原因，提交后由平台审核处理。',
  },
  {
    q: '客服工作时间？',
    a: '客服在线时间为周一至周日 9:00 - 21:00，留言将在工作时间内尽快回复。',
  },
]
